module.exports = __webpack_public_path__ + "img/histortReport4.a9dcdf81.png";